<template>
  <div class="chat-comment" v-if="page.vis">
    <div class="comment-panel" @click.stop="() => {}">
      <div class="header">
        <div class="title">给我留言</div>
        <i class="iconfont icon-close" @click="close" />
      </div>
      <div class="body" v-loading="page.loading">
        <el-alert class="alert" title="当前客服不在线，如需帮助请留言" type="warning" show-icon :closable="false" />
        <custom-assembly
          ref="dataFormRef"
          v-model="page.dataForm"
          v-bind="page.formProps"
          @complete="page.loading = false"
        />
        <el-button class="btn" type="primary" @click="confirm" :loading="page.loading">发送</el-button>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ElMessage } from 'element-plus'
import CustomAssembly from '@/components/custom/custom-assembly.vue'
import { reactive, ref, defineExpose, defineEmits, getCurrentInstance, defineProps, nextTick } from 'vue'
import { deepCopy } from '@/utils'
const props = defineProps({
  sessionStatus: {
    type: [String, Number],
    default: 0
  },
  custInfo: {
    type: Object,
    default: () => {}
  },
  orgId: {
    type: [String, Number],
    default: ''
  }
})
const emit = defineEmits(['confirm'])
const { proxy } = getCurrentInstance()
const page = reactive({
  vis: false,
  loading: false,
  dataForm: {},
  formProps: {
    isEditor: true,
    labelWidth: '100px',
    meta: {
      formList: [],
      groupList: []
    }
  }
})
const dataFormRef = ref(null)

const open = () => {
  page.vis = true
  page.loading = true
  Promise.allSettled([getCustomField(), getFieldGroup()]).then((res) => {
    if (res[0].value && res[0].value.length > 0) {
      page.formProps.meta.formList = res[0].value
    }
    if (res[1].value) {
      let json = JSON.parse(res[1].value)
      page.formProps.meta.groupList = json?.msgField || {}
    }
    if (page.formProps.meta.formList.length > 0 && page.formProps.meta.groupList.length > 0) {
      nextTick(() => {
        dataFormRef.value?.init()
      })
    }
  })
}

const close = () => {
  page.vis = false
  page.dataForm = {}
}
const confirm = () => {
  dataFormRef.value.submitFormReturn(async (valid) => {
    if (valid) {
      page.loading = true
      let data = { msgContent: '', mobile: '', realName: '' }
      data.orgId = props.orgId
      data.sessionId = proxy.$ws.sessionInfo?.sessionId
      data.custId = props.custInfo?.custId
      data.workingTimeFlag = props.sessionStatus == 3 ? 1 : 0
      data.extendedFields = JSON.stringify(deepCopy(page.dataForm))
      let res = await proxy.$http.post('/app/custClient/saveLeaveMsg', data)
      if (res.code === 0) {
        emit('confirm', data)
        close()
      } else {
        ElMessage.error(res.msg)
      }
      page.loading = false
    }
  })
}
// 获取留言自定义字段
const getCustomField = () => {
  return new Promise((resolve) => {
    let params = { orgId: props.orgId || 10, type: 5 }
    proxy.$http.post('/app/custClient/getshowlist', params).then((res) => {
      resolve(res.data)
    })
  })
}

// 获取留言配置字段组
const getFieldGroup = async () => {
  return new Promise((resolve) => {
    proxy.$http.post(`/app/custClient/config`, {
      key: 'leave.word',
      orgId: props.orgId
    }).then((res) => {
      resolve(res.data)
    })
  })
}
defineExpose({
  open
})
</script>
<style scoped lang="less">
.chat-comment {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .comment-panel {
    background-color: #ffffff;
    border-radius: 4px;
    width: 90%;
    max-width: 400px;

    .header {
      padding: 0 10px;
      line-height: 62px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #eee;

      .title {
        font-weight: bold;
      }

      .icon {
        color: #999999;
        cursor: pointer;
      }
    }

    .body {
      padding: 10px;

      .alert {
        margin-bottom: 10px;
      }

      :deep(.el-form) {
        max-height: 400px;
        overflow-y: auto;
      }
    }

    .btn {
      width: 100%;
      border: none;
    }
  }
}
</style>
